/*
----- Read More ----- 
This services multiple ways of revealing data:
- The simplest being read more and less arrows which just show a but then the content.
- To then showing a single piece of the content i.e just 200px of it.
- Or to showing a part of the content then scrolling to a anchor point and then triggering some tabbed notes.
*/

var instances = {}

function getInstanceId(context) {
    if (!context) {
        AXISDebug.output(3,"Read More: No context provided");
        return false;
    }
    let id = context.attr(expressSelectors()['axis-read-more']['instance']);
    if (!id) {
        AXISDebug.output(3,"Read More: No Id found, has this element been initialised?");
        return false;
    } else {
        return id;
    }
}

function setContext(id, value) {
    return instances[id]['context'] = value;
}

function getContext(id) {
    return instances[id]['context'];
}

function setContentContainer(id, value) {
    return instances[id]['content-container'] = value;
}

function getContentContainer(id) {
    return instances[id]['content-container'];
}

function setMobileOnly(id, value) {
    return instances[id]['mobile-only'] = value;
}

function getMobileOnly(id) {
    return instances[id]['mobile-only'];
}

function setClosedText(id, value) {
    return instances[id]['closed-text'] = value;
}

function getClosedText(id) {
    return instances[id]['closed-text'];
}

function setOpenText(id, value) {
    return instances[id]['open-text'] = value;
}

function getOpenText(id) {
    return instances[id]['open-text'];
}

function setTitleText(id, value) {
    return instances[id]['title-text'] = value;
}

function getTitleText(id) {
    return instances[id]['title-text'];
}

function setClosedHeight(id, value) {
    return instances[id]['closed-height'] = value;
}

function getClosedHeight(id) {
    return instances[id]['closed-height'];
}

function setRevealStatus(id, value) {
    return instances[id]['reveal-status'] = value;
}

function getRevealStatus(id) {
    return instances[id]['reveal-status'];
}

function setAnchorPoint(id, value) {
    return instances[id]['anchor-point'] = value;
}

function getAnchorPoint(id) {
    return instances[id]['anchor-point'];
}

function setTabbedNotes(id, value) {
    return instances[id]['tabbed-notes'] = value;
}

function getTabbedNotes(id) {
    return instances[id]['tabbed-notes'];
}

function setTrigger(id, value) {
    return instances[id]['trigger'] = value;
}

function getTrigger(id) {
    return instances[id]['trigger'];
}

function setFadeEnabled(id, value) {
    return instances[id]['fade-enabled'] = value;
}

function getFadeEnabled(id) {
    return instances[id]['fade-enabled'];
}

function setContentTruncate(id, value) {
    return instances[id]['content-truncate'] = value;
}

function getContentTruncate(id) {
    return instances[id]['content-truncate'];
}

function setContainerOffset(id, value) {
    return instances[id]['container-offset'] = value;
} 

function getContainerOffset(id) {
    return instances[id]['container-offset'];
}

function setContentHeight(id, value) {
    return instances[id]['content-height'] = value;
}

function getContentHeight(id) {
    return instances[id]['content-height'];
}


function initialiseAll() {
    $(window).on('load', function() { 
        // Get all instances.
        let elements = $(expressSelectors()['axis-read-more']['initialise']);
        // If any.
        if (elements) {
            elements.each(function () {
                // Get context.
                let context = $(this);
                // Initialise.
                let init = initialise(context);
            });
        }
    });

    $(window).on('changed.zf.mediaquery', function(event, newSize, oldSize) {
        for (let id in instances) {
            // Check container height, suppress fade effect is too little content.
            let containerHeight = calculateContainerHeight(id);
            // Check whether we need additional trigger markup.
            buildRevealTriggerMarkup(id);
        }
    });
}

function initialise(context) {
    // Instance id.
    let id = context.attr(expressSelectors()['axis-read-more']['instance']);
    if (!id) {
        context.attr(expressSelectors()['axis-read-more']['instance'], generateId());
        id = context.attr(expressSelectors()['axis-read-more']['instance']);
        instances[id] = {};
    } else {
        if (AXISDebug.level() >= 3) {
            AXISDebug.output(1, "Read more: Instance already initialised skipping.");
        }
        return false;
    }
    // Wrap inner content in a content container.
    context.wrapInner("<div class='read-more-content'></div>");
    // Find content container.
    let contentContainer = context.find('.read-more-content');
    if (!contentContainer) {
        AXISDebug.output(3,"Read More: Could not find content container.", context);
        return false;
    }
    // Should this read more be only applicable for mobile.
    let rmMobileOnly = (context.attr(expressSelectors()['axis-read-more']['mobile-only']) == 'true');
    // Get the read more button label.
    let rmClosedLabel = context.attr(expressSelectors()['axis-read-more']['closed-text']);
    // Get the read less button labal.
    let rmOpenLabel = context.attr(expressSelectors()['axis-read-more']['open-text']);
    // Title text.
    let titleText = context.attr(expressSelectors()['axis-read-more']['title-text']);
    // Get closed height.
    let closedHeight = parseInt(context.attr(expressSelectors()['axis-read-more']['closed-height']));
    // Reveal functionality.
    let reveal = (context.attr(expressSelectors()['axis-read-more']['reveal']) == 'true');
    // CSS fade.
    let contentFade = context.attr(expressSelectors()['axis-read-more']['content-fade']);
    // Default to on.
    if (contentFade == undefined) {
        contentFade = true;
    } else {
        // Convert result to boolean.
        contentFade = (contentFade === 'true');
    }
    // Whether to truncate content.
    let contentTruncate = (context.attr(expressSelectors()['axis-read-more']['content-truncate']) != undefined);

    // container offset, essentially don't take up all available space, allow some space for vertical alignment.
    let containerOffset = context.attr(expressSelectors()['axis-read-more']['container-offset']); 
    if (!containerOffset) {
        containerOffset = 0;
    }

    let trigger = context.attr(expressSelectors()['axis-read-more']['trigger']);
    if (trigger) {
        // Create jQuery obj for trigger.
        trigger = $('#' + trigger);
        // Add rm instance id to trigger.
        trigger.attr('rm-trigger', id);
        // Check if it has class.
        if (!trigger.hasClass('read-more-trigger')) {
            trigger.addClass('read-more-trigger');
        }
    }

    // Read more anchor ( take the user to section on the page ).
    let anchorPoint = context.attr(expressSelectors()['axis-read-more']['anchor']);
    // Anchor point offset.
    let anchorPointOffset = parseInt(context.attr(expressSelectors()['axis-read-more']['anchor-offset']));
    // Default offset.
    if (!anchorPointOffset) {
        anchorPointOffset = 100;
    }
    // Is the read more content in tabbed notes.
    let tabbedNotes = context.attr(expressSelectors()['axis-read-more']['tabbed-notes']);
    // Create new instance.
    instances[id] = {}
    // Add mobile only condition.
    //instances[id]['rm-mobile-only'] = rmMobileOnly;
    setMobileOnly(id, rmMobileOnly);
    // Add closed label.
    //instances[id]['rm-closed-label'] = rmClosedLabel;
    setClosedText(id, rmClosedLabel);
    // Add open label.
    //instances[id]['rm-open-label'] = rmOpenLabel;
    setOpenText(id, rmOpenLabel);
    // Add title text.
    //instances[id]['rm-title-text'] = titleText;
    setTitleText(id, titleText);
    // Add closed height.
    //instances[id]['rm-closed-height'] = closedHeight;
    setClosedHeight(id, closedHeight);
    // Add reveal status.
    //instances[id]['rm-reveal'] = reveal;
    setRevealStatus(id, reveal);
    // Add anchor point.
    //instances[id]['rm-anchor-point'] = anchorPoint;
    setAnchorPoint(id, anchorPoint);
    // Add anchor point offset
    //instances[id]['rm-anchor-point-offset'] = anchorPointOffset;
    // Add tabbed notes status.
    //instances[id]['rm-tabbled-notes'] = tabbedNotes;
    setTabbedNotes(id, tabbedNotes);
    // Add context.
    //instances[id]['context'] = context;
    setContext(id, context);
    // Add trigger.
    //instances[id]['trigger'] = trigger;
    setTrigger(id, trigger);
    // Set fade status.
    setFadeEnabled(id, contentFade);
    // Set content truncate.
    setContentTruncate(id, contentTruncate);
    // Set content container context.
    setContentContainer(id, contentContainer);
    // Set container offset.
    setContainerOffset(id, containerOffset);
    // Used to enable trigger.
    let contentHeight = 0;
    // Exclusions, if this functionality is nested within the following then it is up to the parent functionality to trigger calculation of the container as this height could change once their async processes has been completed ( i.e a carousel initialising ).
    let exclusions = context.parents('[' + expressSelectors()['axis-carousel']['initialise'] + ']');
    if (!exclusions.length) {
        contentHeight = calculateContainerHeight(id);
    } else {
        prepareCalculation(id, true);
    }
    // Only use in mobile.
    if (rmMobileOnly) {
        context.addClass('mobile-only');
    }

    // TODO: This could be cleanup and put into it's own function.
    // Get the contents actual height as CSS might had been resticting it.
    let contentActualHeight = getContentHeight(id);
    // If not defined then this would have been worked out by the calculateContainerHeight() function.
    if (!closedHeight) {
        closedHeight = getClosedHeight(id);
    }
    // If reveal / read more is configured then assign additional markup + click listener.
    buildRevealTriggerMarkup(id, contentActualHeight);
    // Read more anchor trigger button.
    if (anchorPoint) {
        if (contentActualHeight > closedHeight) {
            if (titleText) {
                titleText = "title=" + titleText;
            }
            context.append("<a id='" + id + "-anchor' class='read-more-anchor' href='" + anchorPoint + "' data-smooth-scroll data-offset='" + anchorPointOffset + "'>" + rmClosedLabel + "</a>");
        }
    }
    // If the content is in the tabbled notes use the anchor point to open the tab.
    if (tabbedNotes) {
        $('#' + id + "-anchor").on('click', function () {
            // If tabs are active.
            let tabId = $(anchorPoint).find('.' + tabbedNotes).parent('div.tabs-panel').attr('id');
            // If accordion active.
            let accordionId = $(anchorPoint).find('.' + tabbedNotes).parent('div.accordion-content').attr('id');

            if (tabId) {
                // Scroll to tabbed notes.
                Foundation.SmoothScroll.scrollToLoc($('#' + tabId + '-label'), {
                    threshold: 50,
                    offset: (getHeaderSize() + 100)
                });
                // If 
                if (!$('#' + tabId).hasClass('is-active')) {
                    $('#' + tabId + '-label').trigger('click');
                    return false;
                }
            } else if (accordionId) {
                // Scroll to tabbed notes.
                Foundation.SmoothScroll.scrollToLoc($('#' + accordionId + '-label'), {
                    threshold: 50,
                    offset: (getHeaderSize() + 100)
                });

                if ($('#' + accordionId + '-label').attr('aria-expanded') == "false") {
                    $('#' + accordionId + '-label').trigger('click');
                    return false;
                }
            } else {
                AXISDebug.output(2, "Read More: Could find id for either tabs or accordian so cannot open content.");
                return false;
            }
        });
    }
    // Trigger initialised event.
    context.trigger('read-more-initialised', id);
}

/*
    Build reveal markup + listener
    Parameters:
    1. Instance Id.
    2. Actual content that is not restricted by CSS, this is crucial for detecting the overflow state.
*/
function buildRevealTriggerMarkup(id, contentHeight = 0) {
    // Get context.
    let context = getContext(id);
    // Get content container.
    let container = getContentContainer(id);
    // Check config if reveal ( read more ) functionality is enabled.
    let reveal = getRevealStatus(id);
    // If not configured then exit.
    if (!reveal) {
        return false;
    }
    // If no content height passed in then try and obtain it.
    if (!contentHeight) {
        contentHeight = getContentUnrestrictedHeight(id);
    }
    // Get closed height.
    let closedHeight = getClosedHeight(id);
    // Get trigger markup.
    let trigger = getTrigger(id);
    // Add button to trigger states.
    if (reveal) {
        // Get the rendered height as this mechanism may have its content completely suppressed which would mean the overflow check would always fail if there is a small amount of content ( i.e. 1 line of text ).
        const renderedHeight = container.height();
        // The primary objective of this check was to detect whether the read more button is actually required i.e. is the content overflowing for cms modules this works with equalisation as well to make sure 6 column cms modules does not expand past the next module in the series.
        if (contentHeight > closedHeight || !renderedHeight) {
            // If no trigger then build one.
            if (!trigger) {
                // TODO: This code assumes that the initialised state is always inactive and will have to be adapted to handle the onload activation.
                // Get closed label.
                let rmClosedLabel = getClosedText(id);
                // If no trigger  has been defined then create one.
                trigger = context.append("<button class=\"readMoreButton\" " + expressSelectors()['axis-read-more']['reveal-button'] + ">" + rmClosedLabel + "</button>");
                // Update instance with trigger.
                //instances[id]['trigger'] = trigger;
                // Get button context.
                trigger = context.find('[' + expressSelectors()['axis-read-more']['reveal-button'] + ']');
                setTrigger(id, trigger);
            }
            // Assign click listener for the trigger button.
            let listener = buttonListeners(id);
            if (!listener) {
                AXISDebug.output(2, "Read More: No trigger defined so there will not be away of revealing the read more's content.");
            }
        }
    }
}

// Calculate how much content we should show.
function calculateContainerHeight(id) {
    // Get context.
    let context = getContext(id);
    // Is the face effect enabled?
    let contentFade = getFadeEnabled(id);
    // Is the content truncate effect enabled?
    const contentTruncate = getContentTruncate(id);
    // Get closed height.
    let closedHeight = getClosedHeight(id);
    // Get content container.
    let contentContainer = getContentContainer(id);
    // Get line-height.
    const lineHeight = parseInt(contentContainer.css('line-height'));
    // Get reveal status.
    let reveal = getRevealStatus(id);
    let parentContentContainer = context.closest('[data-content-container]');
    // Remove class as this will get in the way of content measurements.
    if (context.hasClass('fade-disabled-low-content')) {
        context.removeClass('fade-disabled-low-content');
    }
    // Get the content height.
    let contentHeight = getContentUnrestrictedHeight(id);
    setContentHeight(id, contentHeight);
    // Fallback, this is to primarily support the old way of thinking by using the .read-more-content container instead of [data-content-container] to detect the available space.
    if (!closedHeight && reveal) {
        let containerMaxHeight = contentContainer.css('max-height');
        // Fallback to the max height defined in the CSS.
        if (containerMaxHeight) {
            closedHeight = parseInt(containerMaxHeight);
        }
        closedHeight = setClosedHeight(id, closedHeight);
    }
    // Get cell + content height ( equaliser context ).
    let containerHeights = context.parents('[style*="height"]');
    let containerHeight = 0;
    // Fit read more content into the available space ( carousels [data-content-container] ).
    if (containerHeights && parentContentContainer.length) {
        //console.log("Attempt to work out container height automatically based on available content.", context);
        // Force fade....
        if (!contentFade) {
            contentContainer.addClass('no-fade');
        }
        let restrictedHeight = calculateRestrictedHeight(id, containerHeights);
        // It is unlike that the truncated text is going to fit within the 
        if (contentTruncate) {
            // Calculate the truncated line-height against the restricted height.
            const restrictedTruncate = (Math.floor(restrictedHeight / lineHeight) * lineHeight);
            contentContainer.css('height', restrictedTruncate);
        } else {
            contentContainer.css('height', restrictedHeight);
        }
        // If this instance is part of the exclusion list then remove the flag.
        prepareCalculation(id, false);
    } else {
        // If you're working with a single item ( e.g. Product Enquiry Notes ), this is the original way handling the container height and is more focused towards the reveal mechanism.
        prepareCalculation(id, false);
        // Force fade....
        if (!contentFade) {
            contentContainer.addClass('no-fade');
        }
        if (closedHeight != undefined && closedHeight != NaN) {
            if (contentHeight > closedHeight) {
                contentContainer.css('height', closedHeight);
            }
        }
        
        if (containerHeights.length) {
            containerHeights.each(function() {
                let item = $(this);
                // Container height.
                let itemHeight = item.height();

                if (contentHeight > itemHeight) {
                    containerHeight = itemHeight;
                }
            });
        }
        // Fallback to context for height.
        if (containerHeight == 0) {
            containerHeight = context.height();
        }
        if (!closedHeight && contentFade && containerHeight > 0) {
            closedHeight = (containerHeight + 6);
            // Assign closed height.
            if (contentHeight > closedHeight) {
                contentContainer.css('height', closedHeight);
            }
            // Re-measure container height.
            containerHeight = context.height();

            if (AXISDebug.level() >= 4) {
                AXISDebug.output(1, "Read More: Fade is enabled but no closed height provided so taking container height + adding 6px to allow for fade effect.");
            }
        }
        // If content height is less than cell height then disable fade effect.
        if (contentHeight < containerHeight || contentHeight == containerHeight && contentFade) {
            if (AXISDebug.level() >= 3) {
                AXISDebug.output(1, "Read More: Disabling fade due to not enough content for: " + context.attr('rm-id') + " , Container height: " + containerHeight + " , Content Height: " + contentHeight);
            }
            context.addClass('fade-disabled-low-content');
            // Check whether previously active.
            let isActive = revealIsActive(id);
            // If previously active then toggle inactive state as fade / overflow effect is no longer required due to too little content.
            if (isActive) {
                toggleRevealState(id, false);
            }
        }
    }
    // Handle truncating, this is requires the following CSS rules to be active https://developer.mozilla.org/en-US/docs/Web/CSS/line-clamp
    if (contentTruncate) {
        // Get content height, yes i could use containerHeight but as a procaution I am to re-check it due to all of the manipulation going on above.
        const contentHeight = parseInt(contentContainer.css('height'));
        // Workout how many lines.
        let lines = (contentHeight / lineHeight);
        lines = Math.round(lines);
        // Update CSS Variable.
        contentContainer.css('--read-more-line-clamp', lines);
        if (!contentContainer.hasClass('content-truncate-enabled')) {
            contentContainer.addClass('content-truncate-enabled');
        }
    }

    if (!reveal && containerHeight > 0) {
        contentContainer.css('max-height', containerHeight);
    }
    
    return containerHeight;
}

// This functionality is typically used with entire cms entries which could build an entire page, so that content needs to be hidden before any content container calculation ( such as carousel slides or equalisation ) takes place otherwise the overflowing content will skew the calculcation(s).
function prepareCalculation(id, toggle = false) {
    // Get context.
    let context = getContext(id);
    if (toggle) {
        context.addClass('container-calculation-waiting');
    } else {
        context.removeClass('container-calculation-waiting');
    }
    return context.hasClass('container-calculation-waiting');
}

// If there is a height restiction being imposed by an Equaliser or Bxslider then take the height from that.
function calculateRestrictedHeight(id, parentElements) {
    // Get context.
    let context = getContext(id);
    // Get container offset.
    let containerOffset = getContainerOffset(id);
    // The largest height gets returned.
    let restrictedHeight = 0;
    // Content container, this includes the content around the read more element to calculate the available space.
    let parentContentContainer = context.closest('[data-content-container]');
    // Parent content container height.
    let parentContentContainerHeight = parentContentContainer.height();
    let availableHeight = parentContentContainerHeight;

    context.find('.read-more-content').css('display', 'none');
    if (parentContentContainer) {
        $.each(parentContentContainer.children(), function() {
            let height = $(this).height();
            availableHeight = (availableHeight - height);
        });
        restrictedHeight = availableHeight;
        if (containerOffset) {
            restrictedHeight = (restrictedHeight - containerOffset);
        }
    } else {
        // OLD WAY OF DOING THIS WITHOUT DATA-CONTENT-CONTAINER.

        // Loop over parents that have a height.
        parentElements.each(function() {
            let item = $(this);
            // Container height.
            let itemHeight = item.height();
            // If height is greater then use that.
            if (itemHeight > restrictedHeight) {
                restrictedHeight = itemHeight;
            }
        });
    }

    context.find('.read-more-content').css('display', '');

    
    return restrictedHeight;
}

// Add button listeners for reveal functionality.
function buttonListeners(id) {
    // Check for id.
    if (!id) {
        AXISDebug.output(3, "Read More: Couldn't find instance id from trigger.");
        return false;
    }
    // Put trigger into context.
    //let trigger = instances[id]['trigger'];
    let trigger = getTrigger(id);
    if (!trigger) {
        AXISDebug.output(3, "Read More: Trigger underfined.")
        return false;
    }
    // Add click listener to toggle button.
    trigger.on('click', function (event) {
        // Prevent default behavour.
        event.preventDefault();
        // Get context of button.
        let context = $(this);
        // Get read more container context.
        let container = getContext(id);
        // Toggle reveal state.
        let toggleReveal = toggleRevealState(id);
    });
    return true;
}

// Toggle reveal active state.
function toggleRevealState(id, active = !revealIsActive(id)) {
    // Get container.
    let context = getContext(id);
    // Button.
    let button = getTrigger(id);
    // Holds button text.
    let buttonText = String();
    if (active) {
        buttonText = getOpenText(id);
        context.add(button).addClass('active');
    } else {
        buttonText = getClosedText(id);
        context.add(button).removeClass('active');
    }
    // Update button text.
    if (buttonText.length) {
        button.html(buttonText);
    }
    return button;
}

function revealIsActive(id) {
    // Get context.
    let context = getContext(id);
    // Work out active state.
    let isActive = context.hasClass('active');
    return isActive;
}

// Get the content actual height, attempt to remove container CSS, this is required to determine overflow / reveal toggle.
function getContentUnrestrictedHeight(id) {
    // Get the container.
    let container = getContentContainer(id);
    // Clear our any calculated heights.
    container.css('height', '');
    // Remove any height restriction(s) to get the actual content height, this is necessary to determine whether the fade effect is required ( i.e if content height == container height then we don't need to add fade effect).
    container.css('max-height', 'unset');
    // Get the height.
    let height = container.height();
    // Re-apply content height restriction(s).
    container.css('max-height', '');
    return height;
}


// To Future Kieran ...... If you feel compelled to make this functionality get dynamically loaded in via webpack bundles, you first need to initialise from an attibute instead CSS class, that is a manual mark change to very instance of this funcitonality.

var AXISReadMore = $.AXISReadMore = {
    initialiseAll: () => {
        return initialiseAll();
    },
    initialise: (context) => {
        return initialise(context);
    },
    calculateContainerHeight: (context) => {
        // Get instance.
        let id = getInstanceId(context);
        if (!id) {
            if (AXISDebug.level() >= 3) {
                AXISDebug.output("Read More: Instance has not been initialised yet, so waiting for intialise event to be fired.", context);
            }
            // If not initialised yet then wait for event to be fired.
            context.on('read-more-initialised', function(event, id) {
                // Remove listener as its no longer required.
                context.off('read-more-initialised', id);
                return calculateContainerHeight(id);
            });
        } else {
            return calculateContainerHeight(id);
        }
        
    },
    prepareCalculation: (context, toggle) => {
        // Get instance.
        let id = getInstanceId(context);
        return prepareCalculation(id, toggle);
    }
}

export { AXISReadMore }